/* Elvaly : animations, choix du coloris, gestes du rituel. Relancé à chaque modification dans l'éditeur de thème. */
(function () {
  if (window.__elvalyAccueil) return;
  window.__elvalyAccueil = true;

  var editeur = function () { return window.Shopify && Shopify.designMode; };
  var calme = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -8% 0px' }) : null;

  function init(root) {
    root = root || document;
    // Apparition au défilement : seuls les éléments hors écran sont animés ; coupée dans l'éditeur.
    if (io && !editeur()) {
      root.querySelectorAll('.elv .reveal, .elv .mask').forEach(function (el) {
        if (el.dataset.elvObs) return;
        el.dataset.elvObs = '1';
        if (el.getBoundingClientRect().top > window.innerHeight) io.observe(el);
      });
    }
    // Choix du coloris : nom affiché, variante envoyée au panier, photo et couleur de l'aplat.
    root.querySelectorAll('[data-elv-product]').forEach(function (box) {
      if (box.dataset.elvInit) return;
      box.dataset.elvInit = '1';
      var name = box.querySelector('[data-elv-name]');
      var input = box.querySelector('input[name="id"]');
      var btns = box.querySelectorAll('.sw button');
      btns.forEach(function (b) {
        b.addEventListener('click', function () {
          btns.forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
          b.setAttribute('aria-pressed', 'true');
          var id = b.getAttribute('data-id');
          if (input) input.value = id;
          var bg = b.getAttribute('data-bg');
          if (bg) { box.style.setProperty('--ap', bg); box.setAttribute('data-ink', b.getAttribute('data-ink') || 'clair'); }
          box.querySelectorAll('[data-vid]').forEach(function (i) { i.classList.toggle('on', i.getAttribute('data-vid') === id); });
          if (name) {
            name.classList.add('swap');
            setTimeout(function () { name.textContent = b.getAttribute('data-name'); name.classList.remove('swap'); }, 180);
          }
        });
      });
    });
    // Rituel : l'image suit le geste survolé ou touché ; défilement lent tant que personne n'interagit.
    root.querySelectorAll('[data-elv-rituel]').forEach(function (box) {
      if (box.dataset.elvInit) return;
      box.dataset.elvInit = '1';
      var btns = [].slice.call(box.querySelectorAll('.rl-list button'));
      var photos = box.querySelectorAll('.rl-ph');
      var cur = 0, timer = null;
      function show(i) {
        cur = i;
        btns.forEach(function (b, k) { b.setAttribute('aria-pressed', k === i ? 'true' : 'false'); });
        photos.forEach(function (p, k) { p.classList.toggle('on', k === i); });
      }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      btns.forEach(function (b, k) {
        b.addEventListener('mouseenter', function () { stop(); show(k); });
        b.addEventListener('focus', function () { stop(); show(k); });
        b.addEventListener('click', function () { stop(); show(k); });
      });
      if (!calme && !editeur() && btns.length > 1 && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (es) {
          es.forEach(function (e) {
            if (e.isIntersecting && !timer && !box.dataset.elvTouche) {
              timer = setInterval(function () { show((cur + 1) % btns.length); }, 4500);
            } else if (!e.isIntersecting) { stop(); }
          });
        }, { threshold: 0.4 }).observe(box);
        box.addEventListener('pointerdown', function () { box.dataset.elvTouche = '1'; stop(); });
        box.addEventListener('mouseenter', function () { box.dataset.elvTouche = '1'; stop(); });
      }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();